import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-programlist',
  templateUrl: './programlist.component.html',
  styleUrls: ['./programlist.component.scss']
})

export class ProgramlistComponent {

  public dataListing:any=[];
  public AllData:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p :any= 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public searchKey1:any='';
  public typeKey:any='';
  public confirmStatus: boolean = false;
  public Ids:any=''; 
  public statuskey:any='';
  public sortType:any='desc';

  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");  
      if(localStorage.getItem('gra_pogeno')) {
      this.p=localStorage.getItem('gra_pogeno');
      localStorage.removeItem('gra_pogeno');
    }  
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

     getDetail(page:any){ 
      this.loading= true; 
      var url:any='/program-listing?page='+page;
      if(this.searchKey !=''){
        url=url+'&search='+this.searchKey;
      }
      if(this.typeKey !=''){
        url=url+'&type='+this.typeKey;
      } 
      if(this.statuskey !=''){
        url=url+'&status='+this.statuskey;
      }
      if(this.searchKey1 !=''){
        url=url+'&creator_search='+this.searchKey1;
      } 
     url=url+'&sortBy=createdAt'+'&sortOrder='+this.sortType;
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {
          if(response.data.record.length !=0){
            response.data.record.filter((el:any)=>{
              if(el.program_image ==''){
                el.program_image = 'assets/images/default_img.png';   
              }
            })
          }  
          this.AllData=response.data;
          this.dataListing= response.data.record;  
          this.totalCount = response.data.total; 
          this.loading=false;
        } else {
          this.dataListing=[];  
          this.AllData=[];
          this.totalCount = response.data.total; 
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

    redirect(item:any,type:any){
      this.Ids =item._id;
       localStorage.setItem('gra_pogeno',this.p);
      localStorage.setItem('gra_EditData',JSON.stringify(item));
        if(type ==1){
          this.router.navigate(['/program-detail']);
        } else {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
          }).then((result:any) => {
            let statusType: number = 0;
            if (result.isConfirmed) {
             this.delete();
            }
          });
        }
      }
    
      delete(){
        var url='/program-delete';
        this.service.PostApis({'id':this.Ids},url).subscribe(((response:any)=>{
          if(response.success ==1) {  
            this.loading=false;
            this.p=1;
            this.getDetail(this.p);
          } else {
            this.loading=false;
          }
        }), (error) => { this.loading =false; });
    
      } 




    updateStatus(data:any,status:any){
      Swal.fire({
        title: 'Are you sure?',
       text: "You want to change the status?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!',
      }).then((result:any) => {
        if (result.isConfirmed) {
          this.update(data,status);
        } else {
          this.getDetail(this.p);
        }
      });
  
    }
  
    update(data:any,status:any){
      var url='/program-update';
      var detail={
        "status": status,
        "id": data
    }
      this.service.updateApi(detail,url).subscribe(((response:any)=>{
        if(response.success ==1){         
          this.loading=false; 
          this.p=1; 
          this.getDetail(this.p);
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error:any) => {
        this.loading=false;
      });
    }


    reset(){
      this.p=1;
      this.searchKey='';
      this.searchKey1='';
      this.typeKey='',
      this.statuskey='';
      this.getDetail(this.p);
    }

    ReviewState(data:any){
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Change It!',
      }).then((result:any) => {
        let statusType: number = 0;
        if (result.isConfirmed) {
          var url='/change-content-status';
          var detail={
            "contentType": 'program',
            "id": data
        }
          this.service.PostApis(detail,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.loading=false; 
              this.p=1; 
              this.getDetail(this.p);
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
        }
      });
  
    }
}
